import { DashboardCardDescription } from '@Dashboard/Layout/DashboardCard';
import { Box, Divider } from '@tonic-one/react';
import { t } from 'i18next';
import HighRiskRecipientsChart from './chart';
import HighRiskRecipientsTable from './table';
import React from 'react';

const HighRiskRecipients = (props: { day: string; insightsData: any }) => {
  return (
    <Box>
      <DashboardCardDescription>
        {t('riskUser.recipient.maliciousDesc')}
      </DashboardCardDescription>
      <HighRiskRecipientsChart
        insightsData={props.insightsData}
        day={props.day}
      />
      <Divider orientation="horizontal" position="relative" mb="24px" />
      <HighRiskRecipientsTable
        insightsData={props.insightsData}
        day={props.day}
      />
    </Box>
  );
};

export default HighRiskRecipients;
